import { useAuthenticatedQuery } from "@l2r-front/l2r-auth"
import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_SPEEDINGS } from "../../../../common/constants/modules"

import { speedingsQueryKeys } from "./queryKeys"

export function useTraffics(parameters = {}, config = {}) {
    const url = "traffic/traffics/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = useExtendWithSubnetworks({
        ...parameters,
        project: selectedNetwork.slug,
    }, API_MODULE_SPEEDINGS)

    const queryKey = speedingsQueryKeys.traffics(queryParameters)

    return useAuthenticatedQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}